import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import StyledModal from "components/Modal";
import WarningBox from "components/WarningBox";

import { useAppDispatch } from "store/hooks";
import {
  deleteIbanAccountByUid,
  getIbanAccounts,
  EditableIbanAccount,
} from "store/features/ibanAccountSlice";

import { formatIban } from "shared/functions/formatIban";

interface AccountDeleteModalProps {
  isOpen: boolean;
  account: EditableIbanAccount | null;
  onClose: () => void;
}

const AccountDeleteModal: React.FC<AccountDeleteModalProps> = (props) => {
  const { isOpen, account, onClose } = props;
  const dispatch = useAppDispatch();

  const onSubmit = async () => {
    account?.ibanAccountUid &&
      (await dispatch(deleteIbanAccountByUid(account.ibanAccountUid)).unwrap());
    await dispatch(getIbanAccounts()).unwrap();
    onCloseModal();
  };

  const onCloseModal = () => {
    onClose();
  };

  return (
    <StyledModal
      isOpen={isOpen}
      onClose={onCloseModal}
      title="Видалити реквізити"
      content={
        <>
          <WarningBox content="Видалення реквізитів не призведе до видалення вже згенерованих платіжних посилань, що використовують ці реквізити." />
          {/* TODO: create separate component for info */}
          <Box
            sx={{
              borderRadius: 1,
              border: "1px solid #E5E5E5",
              p: "12px 16px",
              m: "16px 0",
            }}
          >
            <Typography variant="subtitle2" color="grey800" sx={{ mb: 0.5 }}>
              Назва
            </Typography>
            <Typography variant="body2" sx={{ overflowWrap: "anywhere" }}>
              {account?.organizationName || ""}
            </Typography>
            <Box sx={{ m: "12px 0", border: "1px solid #E5E5E5" }} />
            <Typography variant="subtitle2" color="grey800" sx={{ mb: 0.5 }}>
              ЄДРПОУ / РНОКПП
            </Typography>
            <Typography variant="body2">
              {account?.identificationCode || ""}
            </Typography>
            <Box sx={{ m: "12px 0", border: "1px solid #E5E5E5" }} />
            <Typography variant="subtitle2" color="grey800" sx={{ mb: 0.5 }}>
              IBAN
            </Typography>
            <Typography variant="body2">
              {formatIban(account?.iban || "")}
            </Typography>
          </Box>
        </>
      }
      onAction={onSubmit}
      actionBtnText="Видалити"
      actionBtnColor="error"
      actionBtnBorder
    />
  );
};

export default AccountDeleteModal;
